import { render, staticRenderFns } from "./purchase-order.vue?vue&type=template&id=d423edd6&scoped=true&"
import script from "./purchase-order.vue?vue&type=script&lang=js&"
export * from "./purchase-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d423edd6",
  null
  
)

export default component.exports